import { render, staticRenderFns } from "./ReviewIcon.vue?vue&type=template&id=13b24b2e&"
import script from "./ReviewIcon.vue?vue&type=script&lang=js&"
export * from "./ReviewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports